import {useTranslation} from 'hooks/translations/useCustomTranslation';
import useCustomController from 'hooks/useCustomController';
import {ReactNode} from 'react';
import {useFormContext} from 'react-hook-form';

import {StandardTextFieldProps} from '@mui/material';

import TextField from '../TextField';

interface FormInputTextProps extends Omit<StandardTextFieldProps, 'variant'> {
  name: string;
  label?: ReactNode;
  placeholder?: string;
  variant?: 'standard' | 'filled';
  subText?: string;
  validateOnBlur?: boolean;
  maxCharacter?: number;
}
export const FormInputText = ({
  name,
  label,
  placeholder,
  variant,
  subText,
  validateOnBlur,
  maxCharacter,

  ...rest
}: FormInputTextProps) => {
  const {
    formState: {isSubmitted},
    control,
    trigger,
    clearErrors,
    setError,
    setValue,
  } = useFormContext();
  const {
    fieldState: {error},
    field: {value, onBlur, onChange},
  } = useCustomController({control, name, defaultValue: ''});
  const {t} = useTranslation('forms');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!maxCharacter) {
      onChange(e);
      return;
    }

    const newValue = e.target.value;
    if (newValue.length > maxCharacter) {
      setValue(name, newValue.substring(0, maxCharacter));
      setError(name, {
        type: 'maxLength',
        message: t('maxCharacterReached', {count: maxCharacter}),
      });
    } else {
      clearErrors(name);
      setValue(name, newValue);
    }
  };

  return (
    <TextField
      variant={variant}
      error={Boolean(error?.message)}
      helperText={
        subText ? (
          <>
            {error?.message}
            {error?.message ? <br></br> : null}
            {subText}
          </>
        ) : (
          error?.message
        )
      }
      label={label}
      placeholder={placeholder}
      {...rest}
      value={value}
      onChange={handleChange}
      onBlur={event => {
        if (validateOnBlur && !!value) {
          trigger(name);
        }
        if (!value && !isSubmitted) {
          clearErrors(name);
        }
        (onBlur as any)?.(event);
      }}
      name={name}
    />
  );
};
